module.exports = __webpack_public_path__ + "img/MX.d2046be6.svg";